import FaqDesktop from "@/components/FaqDesktop"
import CommonTextInput from "@/components/inputs/CommonTextInput"
import { Logo } from "@/components/Logo"
import { NavigationButtonsFake } from "@/components/NavigationButtonsFake"
import useAnimatedRouter from "@/hooks/useAnimatedRouter"
import { getFirebaseClientAuth } from "@/lib/firebase-client-config"
import { ROUTE_HOME } from "@/navigation"
import { ConfigSlim, ConfigSlimStep } from "@/types/configuration"
import { fetchCsrf, performLogin, performRecaptcha } from "@/utils/client/client_api"
import { validateEmail } from "@/utils/functions"
import { sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth"
import React, { ReactElement, useEffect, useState } from "react"

interface Props {
    texts: any
    locale: string
    configInfo: ConfigSlim
    goToRegistration: () => void
    goToFreePath: () => void
    tenantMessageElement?: ReactElement
}

const WithAuthLoginComponent = ({ locale, texts, configInfo, goToRegistration, goToFreePath, tenantMessageElement }: Props) => {

    const [emailInput, setEmailInput] = useState<string | number>('');
    const [password, setPassword] = useState<string | number>('');

    const [isForgotPasswordMailSent, setIsForgotPasswordMailSent] = useState<boolean>(false);

    enum PageView {
        LOGIN = 1,
        FORGOT_PASSWORD,
    }
    const [pageView, setPageView] = useState(PageView.LOGIN)


    const [csrfToken, setCsrfToken] = useState<string | undefined>(undefined);
    const { animatedRoute } = useAnimatedRouter();

    const getCsrf = async () => {
        const resp = await fetchCsrf();
        setCsrfToken(resp.response.csrfToken);
    }

    useEffect(() => {

        getCsrf();
    }, []);

    const handleLogIn = async () => {

        const recaptchaToken = "";
        // const recaptchaToken = await executeRecaptcha("login");
        // const res = await performRecaptcha(recaptchaToken)
        // if (!res.isOk) {
        //     console.error("Error during login", "no recptcha valid");
        // }

        try {

            const emailString = String(emailInput).trim();
            const passwordString = String(password).trim();

            const firebaseClientAuth = await getFirebaseClientAuth();
            if (!firebaseClientAuth) {
                throw new Error('firebaseClientAuth is null');
            }

            const userCredentials = await signInWithEmailAndPassword(firebaseClientAuth, emailString, passwordString);
            if (userCredentials.user) {
                const token = await userCredentials.user.getIdToken();

                const response = await performLogin(emailString, token, csrfToken ?? '', recaptchaToken);
                if (response.isOk) {
                    animatedRoute(ROUTE_HOME);
                } else {
                    console.error(response);
                }

            } else {
                // TODO Manage Wrogn user/pass
            }
        } catch (error) {
            console.error("Error during login", error);
            // TODO Manage Wrogn user/pass
        }
    }



    const handleRetrievePassword = async () => {
        try {

            const emailString = String(emailInput).trim();

            const firebaseClientAuth = await getFirebaseClientAuth();
            if (!firebaseClientAuth) {
                throw new Error('firebaseClientAuth is null');
            }

            await sendPasswordResetEmail(firebaseClientAuth, emailString);

            console.log(`Password reset email sent to ${emailString}`);

            setIsForgotPasswordMailSent(true)


        } catch (error) {
            console.error("Error during password retrieval", error);
        }
    }

    const renderFreePath = () => {
        if (configInfo.freeModeOnlyLogin) {
            return null;
        }
        return <>
            <div className="mt-5">

            </div>
            <div className="my-5 underline hover:cursor-pointer" onClick={goToFreePath}>
                {texts.executeFlowWithoutLogin}
            </div>
        </>
    }

    const renderRetrievePasswordCard = () => {
        return <form className="col-span-12 lg:col-span-6 2xl:col-span-4 2xl:col-start-8 px-3 py-5 lg:p-8 mb-10 lg:mb-0 border-2 border-orangeH3 rounded-habaButton" onSubmit={handleRetrievePassword}>
            <div className="my-5">
                <h3 className="mb-5 text-orangeH3">
                    {texts.retrievePassword}
                </h3>
                <div className="">
                    <CommonTextInput
                        type='email'
                        labelText={texts.emailLabel}
                        isMandatory={true}
                        inputText={emailInput}
                        setInputText={setEmailInput}
                    />

                </div>
                {isForgotPasswordMailSent ? <h4>Email inviata</h4> : null}
            </div>
            <div className="flex justify-center mb-5">
                <button className="text-center  hover:cursor-pointer" onClick={() => setPageView(PageView.LOGIN)}>
                    Torna al <span className="text-orangeH3 font-fraunces font-bold uppercase underline">login</span>
                </button>

            </div>

            <div className="flex justify-end">
                <NavigationButtonsFake
                    text={'Invia email di recupero'}
                    stepIsValidated={!!emailInput && validateEmail(String(emailInput))}
                    onClick={handleRetrievePassword}
                />
            </div>

        </form>
    }

    const renderLoginCard = () => {
        return <form className="col-span-12 lg:col-span-6 2xl:col-span-4 2xl:col-start-8 px-3 py-5 lg:p-8 mb-10 lg:mb-0 border-2 border-orangeH3 rounded-habaButton" onSubmit={handleLogIn}>
            <div className="mt-5">
                <h3 className="mb-5">
                    {texts.loginTitle}
                </h3>
                <div className="mb-5">
                    <CommonTextInput
                        type='email'
                        labelText={'E-mail'}
                        autoComplete="username"
                        isMandatory={true}
                        inputText={emailInput}
                        setInputText={setEmailInput}
                        labelClassName={"text-left"}
                    />

                </div>

                <div >
                    <CommonTextInput
                        type='password'
                        labelText={'Password'}
                        isMandatory={true}
                        minLength={4}
                        maxLength={20}
                        autoComplete="current-password"
                        inputText={password}
                        setInputText={setPassword}
                        labelClassName={"text-left"}
                        rightButton={
                            <button className="text-center bg-orangeH3 rounded-habaButton px-3 text-smokeH font-bold hover:cursor-pointer mt-3" onClick={() => setPageView(PageView.FORGOT_PASSWORD)}>
                                <span>{texts.forgotten}?</span>
                            </button>
                        }
                    />
                </div>
            </div>
            <div className="flex justify-center  my-8">
                <button className="text-center  hover:cursor-pointer" onClick={goToRegistration}>
                    {texts.registrationTitle}
                </button>
            </div>
            <div className="flex justify-end">
                <NavigationButtonsFake
                    text={texts.cta}
                    stepIsValidated={!!emailInput && validateEmail(String(emailInput)) && !!password}
                    onClick={handleLogIn}
                />
            </div>
            {
                renderFreePath()
            }

        </form>
    }

    const renderPageContent = () => {

        switch (pageView) {
            case PageView.LOGIN:
                return renderLoginCard();
            case PageView.FORGOT_PASSWORD:
                return renderRetrievePasswordCard();
        }
    };


    return (
        <div className="h-full flex flex-col justify-center text-center mt-12 ">
            <div className="grid grid-cols-12 lg:gap-20">
                <div className="col-span-12 lg:col-span-6 2xl:col-span-4 2xl:col-start-2 lg:flex lg:flex-col lg:justify-between">
                    <div>
                        <h1 className="mb-3">
                            {texts.title1} <span className="font-fraunces text-orangeH3">{texts.title2}</span>
                        </h1>
                        <h1 className="mb-10 lg:mb-0">
                            {texts.title3}
                        </h1>
                    </div>
                    <div className="mb-10 lg:mb-0 flex justify-center items-center">
                        <Logo />
                    </div>
                    <div className="">


                        {tenantMessageElement}

                        <div className="mb-3 text-lg">
                            {texts.text1}
                        </div>

                        {/* <div className="mb-3 text-lg lg:mb-0">
                            {texts.text2}
                        </div> */}
                    </div>
                </div>
                {renderPageContent()}
            </div>

            <div className="grid grid-cols-12 lg:gap-20">
                <div className="col-span-12 lg:col-span-6 lg:col-start-7 px-3 py-5 lg:p-8 mb-10 lg:mb-0 flex justify-center items-center">
                    <span className="text-orangeH3"><FaqDesktop texts={texts} /></span>
                </div>
            </div>

        </div>
    );
}

export default WithAuthLoginComponent;